<template>
  <div class="wrapper">
    <HeaderView />

    <section class="content">
      <router-view />
    </section>

    <FooterView />
  </div>
</template>

<script>
import HeaderView from '@/components/HeaderView.vue'
import FooterView from '@/components/FooterView.vue'

export default {
  name: 'App',
  components: {
    HeaderView,
    FooterView
  },
  mounted() {
    this.observedElements = new Set()

    const wrapSectionTitles = () => {
      document.querySelectorAll('.section__title').forEach(el => {
        if (!el.dataset.emWrapped) {
          const fragment = document.createDocumentFragment()

          const processNode = (node) => {
            if (node.nodeType === Node.TEXT_NODE) {
              const words = node.textContent.split(/(\s+)/)
              words.forEach(word => {
                if (word.trim() === '') {
                  fragment.appendChild(document.createTextNode(word))
                } else {
                  const em = document.createElement('em')
                  em.textContent = word
                  fragment.appendChild(em)
                }
              })
            } else if (node.nodeName === 'BR') {
              fragment.appendChild(document.createElement('br'))
            } else if (node.nodeType === Node.ELEMENT_NODE) {
              fragment.appendChild(node.cloneNode(true))
            }
          }

          Array.from(el.childNodes).forEach(processNode)

          el.innerHTML = ''
          el.appendChild(fragment)
          el.dataset.emWrapped = 'true'
        }
      })
    }

    wrapSectionTitles()

    const handleSectionTitle = (el) => {
      el.classList.add('section__title_show')
    }

    const handleFadeIn = (el) => {
      el.classList.add('fadeIn_active')
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target

          if (el.classList.contains('section__title')) {
            handleSectionTitle(el)
          } else if (el.classList.contains('fadeIn')) {
            handleFadeIn(el)
          }

          this.observer.unobserve(el)
          this.observedElements.delete(el)
        }
      })
    }, { threshold: 0.1 })

    const observeElements = () => {
      document.querySelectorAll('.section__title').forEach(el => {
        if (!this.observedElements.has(el)) {
          this.observer.observe(el)
          this.observedElements.add(el)
        }
      })
      document.querySelectorAll('.fadeIn:not(.section__title)').forEach(el => {
        if (!this.observedElements.has(el)) {
          this.observer.observe(el)
          this.observedElements.add(el)
        }
      })
    }

    observeElements()

    this.mutationObserver = new MutationObserver(() => {
      wrapSectionTitles()
      observeElements()
    })

    this.mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    })
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect()
    }
  }
}
</script>
